<div class="component-container flex justify-center items-center w-full">
  <div class="avatar-panel flex flex-row flex-wrap w-full">
    <div (click)="selectAvatar(avatar)"
         *ngFor="let avatar of avatarOptions"
         [id]="avatar.id"
         class="avatar"
    >
      <div
        [class.selected]="avatar === selectedAvtar || avatar.isSelected"
        class="image-wrapper h-[7rem] w-[7rem]
               rounded-full flex flex-row
               justify-center items-center"
      >
        <app-image
          [loaderAppearance]="'circle'"
          [loaderTheme]="{
            'height': '100%',
            'width': '100%'
          }"
          [url]="avatar.url"
          class="image h-[6rem] w-[6rem]
                 rounded-full border
                 cursor-pointer"
        ></app-image>
      </div>
    </div>
  </div>
</div>
